// Post Model
cv.Post =  Backbone.RESTModel.extend({
  defaults : {
    'stub' : '',

    'share_auto' : '',
    'share_title' : '',
    'share_image' : '',
    'share_description' : '',

    'draft_title' : '',
    'draft' : '',
    'body' : '',
    'status' : '',
    'last_modified' : '',
    'published_at' : '',
    'created_at' : ''
  },

  saveMap : {
    'stub' : 'stub',
    'share_auto' : 'share_auto',
    'share_title' : 'share_title',
    'share_image' : 'share_image',
    'share_description' : 'share_description',

    'draft_title' : 'draft_title',
    'draft' : 'draft',
    'body' : 'body',
    'status' : 'status',
    'share_post' : 'share_post',
    'published_at' : 'published_at'
  },

  urlRoot : function(){
    return cv.api_path + '/posts';
  },

  initialize: function(){
    console.log('Post model loaded.');
  }
});
Cocktail.mixin(cv.Post, cv.mixins.SyncModel);

// PostList Collection
cv.Posts = Backbone.Collection.extend({
  url: function() {
    return cv.api_path + "/posts?" + $.param(this.params);
  },

  initialize: function(options){
    console.log('Post List loaded.');
  },

  model: cv.Post
});
Cocktail.mixin(cv.Posts, cv.mixins.PaginateModel);
